import { render, staticRenderFns } from "./DetallesTarjeta1.vue?vue&type=template&id=5c29c478&"
import script from "./DetallesTarjeta1.vue?vue&type=script&lang=js&"
export * from "./DetallesTarjeta1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports